import { render, staticRenderFns } from "./experienceaddorupdate.vue?vue&type=template&id=55b155a5"
import script from "./experienceaddorupdate.vue?vue&type=script&lang=js"
export * from "./experienceaddorupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports